module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-comp-container"
  }, [(_vm.background) ? _c('div', {
    staticClass: "image-comp-single-1 position-relative"
  }, [_c('img', {
    attrs: {
      "src": _vm.background
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.foreground) ? _c('div', {
    staticClass: "image-comp-single-2",
    class: [_vm.background ? 'position-absolute' : 'position-relative']
  }, [_c('img', {
    attrs: {
      "src": _vm.foreground
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showLogo) ? _c('div', {
    staticClass: "image-comp-logo",
    class: [_vm.background || _vm.foreground ? 'position-absolute' : 'position-relative']
  }, [(_vm.logoColor >= 0.5) ? _c('img', {
    attrs: {
      "src": require("assets/images/coche_logo.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("assets/images/coche_logo_white.png")
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f7aed82!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Util/ImageComposite.vue
// module id = 340
// module chunks = 1